import { render, staticRenderFns } from "./PeriodoAcademicoPage.vue?vue&type=template&id=7fe00689"
import script from "./PeriodoAcademicoPage.js?vue&type=script&lang=js&external"
export * from "./PeriodoAcademicoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports